import { Link } from 'react-router-dom';
import type { SerializedInventoryMeter } from '@enmon/commons/lib/tools';
import { Tooltip } from 'antd';
import { Icon } from 'components/icon';
import type { FC } from 'react';
import { useTheme } from 'styled-components';

interface MergedMeterLinkProps {
  mergedIntoId: SerializedInventoryMeter['merged_into']['id'];
}

export const MergedMeterLink: FC<MergedMeterLinkProps> = ({ mergedIntoId }) => {
  const theme = useTheme();

  return (
    <Tooltip title={`Meter merge into ${mergedIntoId}. Click to view details in Tools.`}>
      <Link to={`/portfolio/meters/${mergedIntoId}`} rel="noreferrer" target="_blank">
        <Icon $fontSize="16px" color={theme.color.core.purple.main['500']} iconString="merge" />
      </Link>
    </Tooltip>
  );
};
